// extracted by mini-css-extract-plugin
module.exports = {"tabs":"BasicTab_tabs__360dK"};